import { render, staticRenderFns } from "./CardTitleDescriptionImage.vue?vue&type=template&id=58ffc486&scoped=true&"
import script from "./CardTitleDescriptionImage.vue?vue&type=script&lang=ts&"
export * from "./CardTitleDescriptionImage.vue?vue&type=script&lang=ts&"
import style0 from "./CardTitleDescriptionImage.vue?vue&type=style&index=0&id=58ffc486&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ffc486",
  null
  
)

export default component.exports